<router-outlet></router-outlet>
<!-- <div>
	<button (click)="testNotification()">Click</button>
</div> -->